import { initFilterOptionsSearch } from './search';

window.addEventListener('DOMContentLoaded', () => {
	initFilterOptionsSearch();
});
 
